<!-- //
请求参数动态表单
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div>
    <el-table
        ref="refSortableFormTable"
        :data="list"
        size="small"
        :row-key="rowKey"
        :header-cell-style="this.tableHeader">
      <el-table-column v-if="dragSortable" header-align="left" label="" width="30" align="left">
        <template slot-scope="{row}">
          <span class="dragSortableHandle iconfont iconliebiao" style="cursor: move"></span>
        </template>
      </el-table-column>
      <el-table-column header-align="left" label="参数名" min-width="100" align="left" prop="paramName">
        <template slot-scope="{row}">
          <el-input v-model="row.paramName"
                    v-if="editMode"
                    clearable
                    style="width: 100%"
                    @change="handleChange"/>
          <span v-else>{{ row.paramName }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="left" label="类型" width="120" align="left" prop="paramType">
        <template slot-scope="{row}">
          <el-select v-if="editMode"
                     v-model="row.paramType"
                     clearable
                     style="width: 100%"
                     @change="handleChange">
            <el-option
                v-for="item in $store.getters.dictType[parameterType]"
                :key="item.value"
                :label="item.text"
                :value="item.value"
            />
          </el-select>
          <span v-else>{{ row.paramType }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="left" label="参数描述" min-width="80" align="left" prop="paramComment">
        <template slot-scope="{row}">
          <el-input v-if="editMode"
                    v-model="row.paramComment"
                    clearable
                    style="width: 100%"
                    @change="handleChange">
          </el-input>
          <span v-else>{{ row.paramComment }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="left" label="示例值" min-width="100" align="left" prop="paramValue">
        <template slot-scope="{row}">
          <el-input v-model="row.paramValue"
                    v-if="editMode || configMode"
                    clearable
                    style="width: 100%"
                    @change="handleChange">
          </el-input>
          <span v-else>{{ row.paramValue }}</span>
        </template>
      </el-table-column>

      <el-table-column header-align="left" label="操作" width="60" align="left" v-if="editMode">
        <template slot-scope="{$index}">
          <el-button size="small"
              type="text"
              icon="el-icon-circle-plus-outline"
              @click="handleAdd($index)">
          </el-button>
          <el-button size="small"
                     type="text"
              icon="el-icon-remove-outline"
              @click="handleDelete($index)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  name: 'ApiQueryParamsForm',
  components: {},
  data() {
    return {
      randomKey: this.$util.UUID(),
      list: [this.initData()]
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    dragSortable: {// 是否可以拖动排序
      type: Boolean,
      default: false
    },
    rowKey: {// 定义的行号，当拖动排序等操作需要
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: ""
    },
    parameterType: String,// 参数类型
    editMode: {// 编辑/只读模式
      type: Boolean,
      default: false
    },
    configMode: {// 配置模式
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  watch: {
    value(val) {
      // console.log("-----value------->", val)
      if (val && val.length > 0) {
        this.list = val;
      } else {
        this.list = [this.initData()];
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dragSortable) {
        this.initSortable();
      }
    });
  },
  methods: {
    initSortable() {
      console.log("初始化排序组件")
      let elTable = this.$refs.refSortableFormTable.$el;
      const elTbody = elTable.querySelectorAll(".el-table__body-wrapper > table > tbody")[0];
      // console.log("---------->", elTbody);
      Sortable.create(elTbody, {
        animation: 150, // 动画
        // sort: true,
        handle: '.dragSortableHandle',
        onEnd: (evt) => {
          const curRow = this.list.splice(evt.oldIndex, 1)[0];
          this.list.splice(evt.newIndex, 0, curRow);
        },
      })
    },
    initData() {
      return {id: this.$util.UUID(), paramName: null, paramType: null, paramValue: null, paramComment: null};
    },
    /**
     * 新增
     */
    handleAdd(index) {
      this.list = this.list || []
      this.list.splice(index + 1, 0, this.initData());
    },
    /**
     * 删除
     * @param index
     */
    handleDelete(index) {
      this.list.splice(index, 1);
      if (this.list.length <= 0) {
        this.list = [this.initData()]
      }
    },

    handleChange(val) {
      this.$emit('change', this.list);
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;
  font-weight: 600;
  padding: 0 5px;
}

:deep(.el-table .cell) {
  padding-left: 2px;
  padding-right: 0;
}

:deep(.el-table th.el-table__cell .cell) {
  padding-left: 5px;
  padding-right: 0;
}

:deep(.el-table--mini .el-table__cell) {
  padding: 0 5px !important;
}

:deep(.el-table--mini td.el-table__cell) {
  padding: 5px;
}
</style>
